const generateToWeeksTime = () => {
  const weeksToSeconds = {};
  for (let week = 1; week <= 52; week++) {
    const seconds = week * 604800; // 604800 seconds in a week
    weeksToSeconds[seconds] = `${week} week${week > 1 ? 's' : ''}`;
  }
  return weeksToSeconds;
};

const OffsetToWeeksTime = generateToWeeksTime();

export default OffsetToWeeksTime;



// WEBPACK FOOTER //
// ./src/components/sitewide/OffsetToWeeksTime.js